import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/sms-log`, {params})
    },
    listStatuses(params) {
        return Vue.axios.get(`/sms-log/statuses`)
    },
    delete(params){
        return Vue.axios.post(`/sms-log/delete`, params)
    }
}
